import { Link } from 'gatsby';
import * as React from 'react';
import { isEmpty } from 'lodash';

import { styled } from '@mui/material/styles';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

import { getEventDate, getYear } from '../../../../../utils/functions';
import { useMediaQuery, useTheme } from '@mui/material';

const TimelineItems = styled(TimelineItem)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
    '&::before': {
      padding: 0,
    },
  },
}));

const TimelineWrapper = styled(Timeline)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: '30px 0 0 0',
  },
}));

const TimelineContentDiv = styled(TimelineContent)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
}));

const Dots = styled(TimelineDot)(({ theme }) => ({
  width: '16px',
  height: '16px',
  margin: 0,
  color: '#3B3B3B',
  borderColor: '#3B3B3B',

  [theme.breakpoints.down('sm')]: {
    margin: '0 auto',
    zIndex: 1,
    marginTop: '-8px',
  },
}));

const Connector = styled(TimelineConnector)(({ theme }) => ({
  backgroundColor: '#3B3B3B',

  [theme.breakpoints.down('sm')]: {
    height: '60px',
  },
}));

const EventContent = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '360px',
  height: '230px',
  margin: '0 auto',
  borderBottom: '8px solid transparent',
  transition: '0.3s ease-in-out',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },

  '&:hover ': {
    borderBottom: '8px solid #FECB04',
  },
}));

const Gradient = styled('div')({
  background: 'linear-gradient(360deg, #151515 0%, rgba(0, 0, 0, 0) 65.62%)',
  width: '100%',
  height: '100%',
  position: 'absolute',
  transition: '0.3s ease-in-out',
});

const EventImage = styled('img')({
  width: '100%',
  height: '100%',
});

const EventTitleDiv = styled('div')({
  position: 'absolute',
  bottom: '15px',
  left: '15px',
});

const EventTitle = styled('h4')({
  color: '#FFFFFF',
  opacity: 0.8,
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '23px',
  margin: '10px 10px 0 0',
  textAlign: 'left',
});

const EventTitleDate = styled(EventTitle)({
  fontSize: '14px',
  lineHeight: '18px',
});

const EventThumbnail = ({ event, uid }) => {
  return (
    <Link to={`/timeline-details/event/${uid}`}>
      <EventContent>
        <Gradient />
        <EventImage src={event.featured_image.url} alt="event" />
        <EventTitleDiv>
          <EventTitleDate>{getEventDate(event)}</EventTitleDate>
          <EventTitle>{event.title.text}</EventTitle>
        </EventTitleDiv>
      </EventContent>
    </Link>
  );
};

export default function PeopleTimeline({ events }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <TimelineWrapper position={matches ? 'alternate' : 'left'}>
      {!isEmpty(events.nodes) &&
        events.nodes.map(({ data, uid }, i) => (
          <TimelineItems key={i}>
            <TimelineSeparator>
              <Dots variant="filled" color="primary" />
              <Connector />
            </TimelineSeparator>
            <TimelineContentDiv>
              <EventThumbnail event={data} uid={uid} />
            </TimelineContentDiv>
          </TimelineItems>
        ))}
    </TimelineWrapper>
  );
}
